import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DropdownFilterGroup} from 'src/app/models/filter/dropdown-filter';

@Component({
    selector: 'app-dropdown-fliter',
    templateUrl: './dropdown-fliter.component.html',
    styleUrls: ['./dropdown-fliter.component.scss'],
    standalone: false
})
export class DropdownFliterComponent implements OnInit {

  @Input() filterGroups: DropdownFilterGroup[];
  @Output() changed = new EventEmitter();
  selectedCount: any;
  fieldFilterItem: string[];
  selectedItems: any;

  constructor() {
  }

  ngOnInit(): void {
    this.resetFilter(true);
  }

  selectFilterTypes(fieldFilterItem, $event: any): void {
    fieldFilterItem.selected = !fieldFilterItem.selected;
    this.countSelected();
    $event.stopPropagation();
  }

  countSelected(): void {
    const selectedNumber = this.filterGroups.reduce((sum, filterGroup) => {
      sum += filterGroup.items.reduce((itemsSum, filterItem) => {
        if (filterItem.selected) {
          itemsSum += 1;
        }
        return itemsSum;
      }, 0);
      return sum;
    }, 0);
    this.selectedCount = selectedNumber;
  }

  resetFilter(skipApplyFilter?: boolean): void {
    this.filterGroups.forEach(filterGroup => filterGroup.items.forEach(item => item.selected = false));
    this.countSelected();
    if (!skipApplyFilter) {
      this.applyFilter();
    }
  }

  applyFilter(): void {
    this.selectedItems = [];
    const filter = this.filterGroups.reduce((acc, filterGroup) => {
      const selectedItemsForGroup = filterGroup.items.reduce((accItems, item) => {
        if (item.selected) {
          accItems.push(item.name);
          this.selectedItems.push(item);
        }
        return accItems;
      }, []);
      if (selectedItemsForGroup.length > 0) {
        acc[filterGroup.name] = selectedItemsForGroup;
      }
      return acc;
    }, {});

    this.changed.emit(filter);
    this.countSelected();
  }

}
